import { EmailTemplatePurpose } from '../../../../models/Scheduling'

export interface EmailTemplatePurposeInfo {
  purpose: EmailTemplatePurpose
  label: string
  description: string
}

export const CLIENT_EMAIL_PURPOSES: EmailTemplatePurposeInfo[] = [
  { purpose: EmailTemplatePurpose.INVITATION_TO_BOOK, label: 'Invitation to book a meeting', description: 'Sent when you invite a client to pick a time.' },
  { purpose: EmailTemplatePurpose.BOOKING_REQUEST_DECLINED, label: 'Booking request declined', description: 'Sent when you decline a booking request.' },
  { purpose: EmailTemplatePurpose.INVITATION_TO_REBOOK, label: 'Invitation to rebook a meeting', description: 'Sent when a meeting needs a new time.' },
  {
    purpose: EmailTemplatePurpose.RESCHEDULE_REQUEST_DECLINED,
    label: 'Reschedule request declined',
    description: 'Sent when you decline a reschedule request.',
  },
  {
    purpose: EmailTemplatePurpose.CHANGE_NOTICE,
    label: 'Booking page change notice',
    description: 'Sent when the event type changes before a time is picked.',
  },
  { purpose: EmailTemplatePurpose.CANCELLATION_WITH_MESSAGE, label: 'Cancellation with message', description: 'Sent only when you cancel with a message.' },
  { purpose: EmailTemplatePurpose.REMINDER_TO_BOOK, label: 'Reminder to book a meeting', description: "Sent when a client hasn't booked yet." },
]

export const ADVISOR_EMAIL_PURPOSES: EmailTemplatePurposeInfo[] = [
  { purpose: EmailTemplatePurpose.REQUEST_AWAITING_APPROVAL, label: 'New request awaiting approval', description: 'Sent when a request needs your approval.' },
  { purpose: EmailTemplatePurpose.NEW_BOOKING_NOTIFICATION, label: 'New booking notification', description: 'Sent when a client books without approval.' },
  { purpose: EmailTemplatePurpose.RESCHEDULING_NOTIFICATION, label: 'Rescheduling notification', description: 'Sent when a client reschedules.' },
  {
    purpose: EmailTemplatePurpose.CANCELLATION_NOTIFICATION,
    label: 'Cancellation via booking page',
    description: 'Sent when a client cancels on the booking page.',
  },
]
